/**
 * Konsistenter Page-Header für alle Orbit-Views.
 * Title links, optionale Subtitle, rechts ein Action-Slot.
 */
export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="d-flex align-items-start justify-content-between mb-4">
      <div>
        <h1 className="h3 mb-1">{title}</h1>
        {subtitle && (
          <p className="text-muted small mb-0">{subtitle}</p>
        )}
      </div>
      {actions && <div className="d-flex gap-2">{actions}</div>}
    </div>
  );
}
